import React, {
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react';

import type { ReactNode } from 'react';
import type {
  FilterScalarValue,
  FilterTextValue,
  PractitionerFilterList,
  SetFilterListFn,
} from '../../features/practitioner/lib/filterTypes';

interface ProspectFilterContextValue {
  firstName: FilterTextValue;
  setFirstName: React.Dispatch<React.SetStateAction<FilterTextValue>>;
  lastName: FilterTextValue;
  setLastName: React.Dispatch<React.SetStateAction<FilterTextValue>>;
  filterList: PractitionerFilterList;
  setFilterList: SetFilterListFn;
  prospectSpecialistType: FilterScalarValue;
  setProspectSpecialistType: React.Dispatch<React.SetStateAction<FilterScalarValue>>;
}

const ProspectFilterContext = createContext<ProspectFilterContextValue | null>(null);

export function ProspectFilterProvider({ children }: { children: ReactNode }) {
  const [firstName, setFirstName] = useState<FilterTextValue>(false);
  const [lastName, setLastName] = useState<FilterTextValue>(false);
  const [filterList, setFilterList] = useState<PractitionerFilterList>(false);
  const [prospectSpecialistType, setProspectSpecialistType] = useState<FilterScalarValue>(false);

  const value = useMemo(
    () => ({
      firstName,
      setFirstName,
      lastName,
      setLastName,
      filterList,
      setFilterList,
      prospectSpecialistType,
      setProspectSpecialistType,
    }),
    [firstName, lastName, filterList, prospectSpecialistType],
  );

  return (
    <ProspectFilterContext.Provider value={value}>
      {children}
    </ProspectFilterContext.Provider>
  );
}

export function useProspectFilters(): ProspectFilterContextValue {
  const context = useContext(ProspectFilterContext);
  if (!context) {
    throw new Error('useProspectFilters must be used within ProspectFilterProvider');
  }
  return context;
}
